export const ChevronLeft = (props: any) => <svg width="24" stroke="currentColor" height="24" viewBox="0 0 24 24" fill="none" {...props}  xmlns="http://www.w3.org/2000/svg">
  <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
</svg>
